import type { CSSProperties } from 'react';

export const btnPrimary: CSSProperties = {
  background: 'var(--lumal-primary)', color: 'white', padding: '0.4rem 0.8rem',
  border: 'none', borderRadius: 4, cursor: 'pointer', textDecoration: 'none', display: 'inline-block',
};
export const btnSecondary: CSSProperties = {
  background: 'transparent', color: 'var(--lumal-fg)', padding: '0.3rem 0.6rem',
  border: '1px solid var(--lumal-border)', borderRadius: 4, cursor: 'pointer',
};
export const userBar: CSSProperties = {
  display: 'flex', justifyContent: 'space-between', alignItems: 'center',
  padding: '0.5rem 0', borderBottom: '1px solid var(--lumal-border)', marginBottom: '1rem',
};
export const tabsStyle: CSSProperties = {
  display: 'flex', gap: 4, borderBottom: '2px solid var(--lumal-border)', marginBottom: 16,
};
export const tabBtn: CSSProperties = {
  background: 'transparent', border: 'none', padding: '8px 14px', cursor: 'pointer',
  borderBottom: '2px solid transparent', marginBottom: '-2px', color: 'var(--lumal-muted)',
};
export const tabActive: CSSProperties = {
  borderBottom: '2px solid var(--lumal-primary)', color: 'var(--lumal-primary)', fontWeight: 600,
};
export const tbl: CSSProperties = {
  width: '100%', borderCollapse: 'collapse', background: 'var(--lumal-surface)', marginTop: '0.5rem',
};
export const formStyle: CSSProperties = {
  display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))',
  gap: '0.5rem', marginTop: '0.75rem', padding: '1rem',
  border: '1px solid var(--lumal-border)', borderRadius: 6, background: 'var(--lumal-surface)',
};
export const statCard: CSSProperties = {
  flex: 1, minWidth: 120, padding: '0.75rem 1rem', borderRadius: 8,
  border: '1px solid var(--lumal-border)', background: 'var(--lumal-surface)',
};
export const statNumber: CSSProperties = { fontSize: '1.6rem', fontWeight: 700, color: 'var(--lumal-primary)' };
export const badge: CSSProperties = {
  display: 'inline-block', padding: '1px 8px', borderRadius: 10, fontSize: '0.72rem',
  border: '1px solid var(--lumal-border)',
};
export const drawer: CSSProperties = {
  marginTop: '1rem', padding: '1rem', border: '1px solid var(--lumal-border)',
  borderRadius: 8, background: 'var(--lumal-surface)',
};
export const btnDanger: CSSProperties = {
  background: 'transparent', color: 'var(--lumal-danger)', padding: '0.3rem 0.6rem',
  border: '1px solid var(--lumal-danger)', borderRadius: 4, cursor: 'pointer',
};
